import React from 'react';
import brandLogo from '../assets/careerova-logo.png';

export const BrandLogo = ({ className = '', ...props }) => (
  <img
    src={brandLogo}
    alt="Careerova"
    draggable="false"
    className={className}
    {...props}
  />
);
